var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<button aria-haspopup=\"true\" aria-expanded=\"false\" class=\"btn btn-icon details-toggle\"><span class=\"glyphicon\"></span></button>");;return buf.join("");
}